// InputDto.UnitOfMeasure is a named enum string from the API. The grid shows
// abbreviations, so accept either representation and send the enum name back.
const WEIGHT_UNIT_NAMES: Record<string, string> = {
    g: "Grams",
    gram: "Grams",
    grams: "Grams",
    kg: "Kilograms",
    kilogram: "Kilograms",
    kilograms: "Kilograms",
};

export const needsReceiptUnit = (unit: string): boolean =>
    unit.trim().toLowerCase() === "unspecified";

export const resolveReceiptUnit = (nativeUnit: string, selectedUnit?: string): string => {
    const unit = (needsReceiptUnit(nativeUnit) ? selectedUnit : nativeUnit)?.trim() ?? "";
    return WEIGHT_UNIT_NAMES[unit.toLowerCase()] ?? unit;
};
